import { reactive, toRefs } from 'vue'
import { provideApolloClient } from '@vue/apollo-composable'
import { apolloClient } from 'boot/apollo'
import { useForm, ruleHub } from 'vue3-form'
provideApolloClient(apolloClient)

const state = reactive({
  showB2cMaxRequestPopup: false,
  form: useForm({
    userType: { rules: ['required'] },
    ownership: { rules: ['required'] },
    painPoints: { rules: [], value: [] },
    painPointOther: { rules: [] },
    lastName: { rules: ['lastName'] },
    firstName: { rules: ['firstName'] },
    email: { rules: ['required', 'email'] },
    phoneNumber: { rules: ['phoneNumber', 'required'] }
  })
})

export function useB2CAnalyzer () {
  return {
    ...toRefs(state)
  }
}
